import { _ } from "../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import FileSelectionButtonWidget from "./FileSelectionButtonWidget.js";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner

/**
 * `fileUploadButtonWidget` renders a `fileSelectionButtonWidget` and
 * upload the selected file.
 *
 * @param {Renderable} [spec.label] - This argument is passed
 * unchanged to `fileUploadButtonWidget`.
 * @param {string} [spec.cssClass] - This argument is passed
 * unchanged to `fileUploadButtonWidget`.
 * @param {function} [spec.onSuccess] - This callback is executed with
 * the selected file as first argument followed by arguments
 * `onUpload()` might resolve to.
 * @param {function} [spec.onError] - This callback is executed with
 * the error object, which contains the error message.
 * @param {function} [spec.validate] - This callback is executed with
 * the selected file as argument. The callback must return a truthy
 * value for the upload to proceed.
 * @param {function} spec.onUpload - Called with a file as
 * argument. Should return a promise.
 */
export default class FileUploadButtonWidget extends Widget {
	constructor({
		label,
		onSuccess = () => {},
		onError = () => {},
		validate = () => true,
		onUpload,
		cssClass,
		dataHelpName,
		dataTestName,
	}) {
		super(...arguments);

		this._onSuccess = onSuccess;
		this._onError = onError;
		this._validate = validate;
		this._label = label;

		this._onUpload = onUpload;

		this._fileSelectionButtonWidget = FileSelectionButtonWidget.forFormData(
			{
				label,
				cssClass,
				dataHelpName,
				dataTestName,
				fileSelectedCallback: this._validateAndUpload.bind(this),
			},
		);
	}

	renderContentOn() {
		// empty because all rendering is done in _renderRootOn().
	}

	_renderRootOn(html) {
		html.render(this._fileSelectionButtonWidget);

		return html;
	}

	_validateAndUpload(file) {
		if (!this._validate(file)) {
			return;
		}
		this._upload(file);
	}

	_upload(file) {
		this._setUploadingState();

		this._onUpload(file)
			.then((...rest) => {
				this._resetUploadingState();
				this._onSuccess(file, ...rest);
			})
			.catch((error) => {
				this._resetUploadingState();
				this._onError({ error });
			});
	}

	_setUploadingState() {
		this._fileSelectionButtonWidget.setLabel((html) => {
			html.span(_("Uploading"));
			// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
			html.render(new OldSpinnerWidget({ size: 20 }));
		});

		this._fileSelectionButtonWidget.makeDisabled();
	}

	_resetUploadingState() {
		this._fileSelectionButtonWidget.setLabel(this._label);
		this._fileSelectionButtonWidget.makeEnabled();
	}
}
